import { useContext } from 'react'
import SelectionStateContext from './selection-state-context'


export const useSelectionStateContext = () => useContext(SelectionStateContext)
